(function () {
  var selector = '[data-nscit-geo-download]';
  var countryPromise = null;

  function getRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getDetectedCountry() {
    if (!countryPromise) {
      var root = getRoutesRoot();
      countryPromise = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
        credentials: 'same-origin',
      })
        .then(function (response) {
          if (!response.ok) return '';
          return response.json();
        })
        .then(function (data) {
          return data && data.detected_values && data.detected_values.country
            ? data.detected_values.country.handle || ''
            : '';
        })
        .catch(function () {
          return '';
        });
    }

    return countryPromise;
  }

  function resolveHref(link, country) {
    var chinaUrl = link.getAttribute('data-china-url');
    var globalUrl = link.getAttribute('data-global-url');

    if (country && country.toUpperCase() === 'CN' && chinaUrl) {
      return chinaUrl;
    }

    return globalUrl || chinaUrl || link.href;
  }

  function updateLink(link, country) {
    var href = resolveHref(link, country);
    if (href) link.href = href;

    link.setAttribute('data-nscit-geo-resolved', 'true');
    link.setAttribute('data-nscit-geo-country', country || 'unknown');
  }

  function updateAllLinks() {
    getDetectedCountry().then(function (country) {
      document.querySelectorAll(selector).forEach(function (link) {
        updateLink(link, country);
      });
    });
  }

  function handleClick(event) {
    var link = event.target.closest(selector);

    if (
      !link ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.getAttribute('data-nscit-geo-resolved') === 'true'
    ) {
      return;
    }

    event.preventDefault();

    getDetectedCountry().then(function (country) {
      updateLink(link, country);
      window.location.href = link.href;
    });
  }

  if (!window.NSCITGeoDownload) {
    window.NSCITGeoDownload = {
      init: updateAllLinks,
    };

    document.addEventListener('click', handleClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllLinks, { once: true });
  } else {
    updateAllLinks();
  }
})();
